<template>
  <div class="bill">
    <div class="contentRight2">
      <!-- 账单明细界面 -->
      <div v-if="pages == 1">
        <div class="rightHead">
          <div style="margin:0 0 0 25px;font-size:15px;padding-top:16px;color:#707070;">账单明细</div>
        </div>
        <div class="billHead">
          <div class="row">
            <!-- <el-input class="input1" size="small" placeholder="搜索门店.."></el-input> -->
            <!-- 日期选择 -->
            <div class="block">
              <el-date-picker
                v-model="value2"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </div>
          </div>
          <div class="row select" style="margin-top:20px;">
            <el-select size="small" v-model="value" placeholder="请选择">
              <el-option
                v-for="item in shopList"
                :key="item.storeName"
                :label="item.storeName"
                :value="item.shopStoreId"
              ></el-option>
            </el-select>
            <el-select style="margin-left:20px;" size="small" v-model="value3" placeholder="请选择">
              <el-option
                v-for="item in dealList"
                :key="item.name"
                :label="item.name"
                :value="item.Id"
              ></el-option>
            </el-select>
            <!-- <el-select size="small" class="input1 margin20" value="全部收银员"></el-select> -->
            <el-select style="margin-left:20px;" size="small" v-model="value5" placeholder="请选择" @change="orderStatusChange">
              <el-option
                v-for="item in orderStatusList"
                :key="item.name"
                :label="item.name"
                :value="item.orderStatus"
              ></el-option>
            </el-select>
			<div style="margin-left:20px;width:215px;display: inline-block;">
			  <el-input size="small" v-model="phoneNum" placeholder="搜索手机号"></el-input>
			</div>
          </div>
          <div class="row" style="margin-top:20px;">
            <el-button class="button1" @click="search" type="primary">搜索</el-button>
            <el-button class="button1" @click="clear">重置</el-button>
            <el-button class="button1" @click="excel">账单导出</el-button>
          </div>
        </div>
        <div class="content">
          <!-- <div class="time"> {{value2}}</div> -->
          <div class="time">
            <span v-if="this.value4">
              {{ this.value4[0]}} - {{this.value4[1]}}
            </span>
            <span v-if="this.value6">
              {{this.value6}}
            </span>
            <span v-else>全部</span>
            交易笔数
            <span class="red">{{tableData.orderNum }}笔</span> 交易金额
            <span class="red">{{tableData.money}}元</span> 
            <span v-if="this.value6 == '退款' || this.value6 == '退货退款'">退款金额：<span class="red">{{tableData.refundMoney}}元</span></span>
          </div>
          <!-- 表格 -->
          <div>
            <el-table v-if="tableData.pager" :data="tableData.pager.list" style="width: 100%">
              <el-table-column align="center" prop="createTime" label="日期" width="180"></el-table-column>
              <el-table-column align="center" prop="storeName" label="门店" width="180"></el-table-column>
              <el-table-column align="center" prop="cashierUserFullName" label="收银员"></el-table-column>
              <el-table-column align="center" prop="payMoney" label="交易金额"></el-table-column>
              <el-table-column align="center" label="交易方式">
                <template slot-scope="scope">
                  <span v-if="scope.row.payInterfacePartyType == 1">系统</span>
                  <span v-if="scope.row.payInterfacePartyType == 2">支付宝</span>
                  <span v-if="scope.row.payInterfacePartyType == 3">微信</span>
                  <span v-if="scope.row.payInterfacePartyType == 4">银联支付</span>
                  <span v-if="scope.row.payInterfacePartyType == 5">百付宝</span>
                  <span v-if="scope.row.payInterfacePartyType == 6">QQ钱包</span>
                  <span v-if="scope.row.payInterfacePartyType == 7">京东钱包</span>
                  <span v-if="scope.row.payInterfacePartyType == 8">刷卡记账</span>
                  <span v-if="scope.row.payInterfacePartyType == 9">现金记账</span>
                  <span v-if="scope.row.payInterfacePartyType == 10">会员卡支付</span>
                  <span v-if="scope.row.payInterfacePartyType == 11">线下收款</span>
                  <span v-if="scope.row.payInterfacePartyType == 12">支付宝记账</span>
                  <span v-if="scope.row.payInterfacePartyType == 13">微信记账</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="交易状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.orderStatus === 40">完成</span>
                  <!-- <span v-else-if="scope.row.orderStatus === 10">未付款</span> -->
                  <span v-if="scope.row.orderStatus === -50" style="color:red">退款</span>
                  <span v-if="scope.row.orderStatus === -51" style="color:red">退货退款</span>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="refundMoney" width="180" label="退款金额">
                <template slot-scope="scope">
                  {{scope.row.refundMoney == 0 ? "" : scope.row.refundMoney.toFixed(2)}}
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.orderStatus == 40 || scope.row.orderStatus == 10"
                    class="button5"
                    @click="detal(3,scope.row.mallOrderId)"
                  >详情</el-button>
                  <el-button
                    v-if="scope.row.orderStatus == -50 || scope.row.orderStatus === -51"
                    class="button5"
                    @click="detal(2,scope.row.mallOrderId)"
                  >详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页 -->
          <div v-if="totalCount" class="block" style="float:right;margin-top:10px;">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="1"
              :page-size="20"
              layout="total, prev, pager, next, jumper"
              :total="totalCount"
            ></el-pagination>
          </div>
        </div>
      </div>
      <!-- 退款详情界面 -->
      <div v-if="pages == 2" id="page2">
        <div class="rightHead">
          <div style="margin:0 0 0 25px;font-size:15px;padding-top:16px;color:#707070;">账单明细</div>
        </div>
        <div class="billHead2" style="height:40px;">
          <el-breadcrumb class="elArrowText"  separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>
              <a @click="pages = 1,refundSuccess = true" href="javascript:;">账单详细</a>
            </el-breadcrumb-item>
            <el-breadcrumb-item>退款详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="content">
          <div class="row" v-if="!refundSuccess">
            <div class="state column alignCenter">
              <div class="title">交易状态</div>
              <div class="center column">
                <img src="../../assets/icon/tkcg.png" alt />
                <div class="text1">￥{{orderRefundDetalList.refundMoney}}</div>
                <b class="text2" >{{orderDetalList.orderStatus === -50 ? "退款" : "退货退款"}}</b>
              </div>
            </div>
            <div class="primary">
              <div class="title">基本资料</div>
              <div class="primaryContent row">
                <div class="block1">
                  <!-- <div v-if="orderDetalList.orderStatus == 10">交易状态：未付款</div> -->
                  <div v-if="orderDetalList.orderStatus === 40">交易状态：完成</div>
                  <div v-if="orderDetalList.orderStatus === -50">交易状态：退款</div>
                  <div v-if="orderDetalList.orderStatus === -51">交易状态：退货退款</div>
                  <div>退款时间：{{orderRefundDetalList.refundTime}}</div>
                  <div>退款门店：{{orderRefundDetalList.storeName}}</div>
                  <div>退款收银员：{{orderRefundDetalList.cashierUserFullName}}</div>
                </div>
                <div class="block2">
                  <div>原订单号：{{orderDetalList.tradeNo}}</div>
                  <div>退单单号：{{orderRefundDetalList.tradeNo}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="refundSuccess">
            <div class="state column alignCenter">
              <div class="title">交易状态</div>
              <div class="center column">
                <img src="../../assets/icon/tkcg.png" alt />
                <div class="text1">￥{{orderDetalList.gainMoney}}</div>
                <b class="text2">{{orderDetalList.orderStatus === -50 ? "退款" : "退货退款"}}</b>
              </div>
            </div>
            <div class="primary">
              <div class="title">基本资料</div>
              <div class="primaryContent row">
                <div class="block1">
                  <div>交易金额：￥{{orderDetalList.payMoney}}</div>
                  <div>账户信息：{{orderDetalList.gainMoney}}</div>
                  <div>所属门店：{{orderDetalList.storeName}}</div>
                  <!-- <div>收款码：{{orderDetalList.gainMoney}}</div> -->
                  <div>收银员：{{orderDetalList.cashierUserFullName}}</div>
                </div>
                <div class="block2">
                  <div v-if="orderDetalList.payInterfacePartyType == 1">付款方式：系统</div>
                  <div v-if="orderDetalList.payInterfacePartyType === 2">付款方式：支付宝</div>
                  <div v-if="orderDetalList.payInterfacePartyType === 3">付款方式：微信</div>
                  <div>终端流水号：{{orderDetalList.outTradeNo}}</div>
                  <div>时间/日期：{{orderDetalList.createTime}}</div>
                  <div>订单号：{{orderDetalList.tradeNo}}</div>
                </div>
                <div class="block2">
                  <div>结算金额：￥{{orderDetalList.gainMoney}}</div>
                  <div>备注：{{orderDetalList.orderMark}}</div>
                  <div>&nbsp;</div>
                  <div>
                    退款：
                    <span class="red">-￥{{orderDetalList.gainMoney}}</span>
                    <span class="blue" @click="refundSuccess = false">详情</span>
                  </div>
                </div>
                <div>
                  <!-- <el-button class="button6" :disabled="buttonDisabled" @click="print">打印小票</el-button> -->
                </div>
              </div>
            </div>
          </div>
          <!-- 表格 -->
          <div v-if="refundSuccess&&orderDetalGoodsList.pager" style="margin-top:30px;">
            <div style="margin-top:30px;">
              <el-table :data="orderDetalGoodsList.pager.list" style="width: 100%">
                <el-table-column align="center" prop="goodsName" label="商品名称" width="180"></el-table-column>
                <el-table-column align="center" prop="qrcBuyCount" label="数量"></el-table-column>
                <el-table-column align="center" prop="totalTurnoverPrice" label="单价"></el-table-column>
                <el-table-column align="center" prop="turnoverPrice" label="单品小计" style="color:red"></el-table-column>
              </el-table>
            </div>
          </div>
          <!-- 分页 -->
          <div v-if="refundSuccess" class="block" style="float:right;margin-top:10px;">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange2"
              :current-page="1"
              :page-size="7"
              layout="total, prev, pager, next, jumper"
              :total="totalCount2"
            ></el-pagination>
          </div>
        </div>
      </div>
      <!-- 账单明细详情界面 -->
      <div v-if="pages == 3" id="page3">
        <div class="rightHead">
          <div style="margin:0 0 0 25px;font-size:15px;padding-top:16px;color:#707070;">账单明细</div>
        </div>
        <div class="billHead2" style="height:40px;">
          <el-breadcrumb class="elArrowText"  separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>
              <a @click="pages = 1,refundSuccess = true"  href="javascript:;">账单明细</a>
            </el-breadcrumb-item>
            <el-breadcrumb-item>账单明细详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="content">
          <div class="row">
            <div class="state column alignCenter">
              <div class="title">交易状态</div>
              <div class="center column">
                <img src="../../assets/icon/skcg.png" alt />
                <div class="text1">￥{{orderDetalList.gainMoney}}</div>
                <b class="text2" v-if="orderDetalList.orderStatus === 40">完成</b>
                <!-- <b class="text2" v-if="orderDetalList.orderStatus === 10">未付款</b> -->
                <b class="text2" v-if="orderDetalList.orderStatus === -50">退款</b>
                <b class="text2" v-if="orderDetalList.orderStatus === -51">退货退款</b>
              </div>
            </div>
            <div class="primary">
              <div class="title">基本资料</div>
              <div class="primaryContent row">
                <div class="block1">
                  <div>交易金额：￥{{orderDetalList.payMoney}}</div>
                  <!-- <div>账户信息：{{orderDetalList.gainMoney}}</div> -->
                  <!-- <div>会员卡名称：{{orderDetalList.buyerCardName}}</div> -->
                  <div>收银员手机号：{{orderDetalList.cashierUserPhoneNum}}</div>
                  <div>所属门店：{{orderDetalList.storeName}}</div>
                  <!-- <div>收款码：{{orderDetalList.gainMoney}}</div> -->
                  <div>收银员：{{orderDetalList.cashierUserFullName}}</div>
                </div>
                <div class="block2">
                  <div v-if="orderDetalList.payInterfacePartyType == 1">付款方式：系统</div>
                  <div v-if="orderDetalList.payInterfacePartyType === 2">付款方式：支付宝</div>
                  <div v-if="orderDetalList.payInterfacePartyType === 3">付款方式：微信</div>
                  <div>终端流水号：{{orderDetalList.outTradeNo}}</div>
                  <div>时间/日期：{{orderDetalList.createTime}}</div>
                  <div>订单号：{{orderDetalList.tradeNo}}</div>
                </div>
                <div class="block2">
                  <div>结算金额：￥{{orderDetalList.gainMoney}}</div>
                  <div>备注：{{orderDetalList.orderMark}}</div>
                </div>
                <div>
                  <!-- <el-button class="button2" @click="open" type="primary">主动退款</el-button> -->
                  <!-- <el-button class="button6" @click="print" :disabled="buttonDisabled">打印小票</el-button> -->
                </div>
              </div>
            </div>
          </div>
          <!-- 表格 -->
          <div style="margin-top:30px;" v-if="orderDetalGoodsList.pager">
            <el-table :data="orderDetalGoodsList.pager.list" style="width: 100%">
              <el-table-column align="center" prop="goodsName" label="商品名称" width="180"></el-table-column>
              <el-table-column align="center" prop="qrcBuyCount" label="数量"></el-table-column>
              <el-table-column align="center" prop="totalTurnoverPrice" label="单价"></el-table-column>
              <el-table-column align="center" prop="turnoverPrice" label="单品小计" style="color:red"></el-table-column>
            </el-table>
          </div>
          <!-- 分页 -->
          <div class="block" style="float:right;margin-top:10px;">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange2"
              :current-page="1"
              :page-size="7"
              layout="total, prev, pager, next, jumper"
              :total="totalCount2"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { printOrder } from "../api";
import { getLodop } from "@/utils/LodopFuncs";
export default {
  data() {
    return {
      buttonDisabled: false,
      orderDetalList: [], //详情页数组
      //退款成功界面的控制
      refundSuccess: true,
      //pages == 1 账单明细界面pages == 2 退款详情界面 pages == 3 账单明细详情界面
      pages: 1,
      // 表格
      tableData: [],
      // 日期选择
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      totalCount: 0,
      totalCount2: 0,
      value2: "", //日期
      value4: "", //日期
      value: "", //门店选择
      value3: "", //支付方式选择
      value5: "",
      userList: "",
      shopInformation: "",
      orderRefundDetalList:[],
      shopList: [
        { storeName: "全部门店", shopStoreId: "" }
        //门店地址数组
      ],
      dealList: [
        { name: "全部方式", Id: "" },
        { name: "系统", Id: 1 },
        { name: "支付宝", Id: 2 },
        { name: "微信", Id: 3 },
        { name: "银联支付", Id: 4 },
        { name: "百付宝", Id: 5 },
        { name: "QQ钱包", Id: 6 },
        { name: "京东钱包", Id: 7 },
        { name: "刷卡记账", Id: 8 },
        { name: "现金记账", Id: 9 },
        { name: "会员卡支付", Id: 10 },
        { name: "线下收款", Id: 11 },
        { name: "支付宝记账", Id: 12 },
        { name: "微信记账", Id: 13 }
        //交易方式数组
      ],
      orderStatusList: [
        { name: "全部状态", orderStatus: "" },
        // { name: "未付款", orderStatus: 10 },
        { name: "完成", orderStatus: 40 },
        { name: "退款", orderStatus: -50 },
        { name: "退货退款", orderStatus: -51 }
      ],
      orderDetalGoodsList: [],
      id: "",
      value6: "",
	  phoneNum:'',
    };
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    this.userList = userList;
    this.shopInformation = shopInformation;
    //订单明细
    this.MallOrder_mallOrdersdetails();
    this.Shop_shopStores(); //门店列表
  },
  methods: {
    //excel导出
    excel() {
      var userId = this.userList.id;
      var sessionId = this.userList.sessionId;
      var shopStoreId = this.value;
      var orderStatus = this.value5
      if (this.value2) {
        var startDate = this.value2[0];
        var endDate = this.value2[1];
      } else {
        var startDate = "";
        var endDate = "";
      }

      var payInterfacePartyType = this.value3;

      window.open(
        this.url +
          "qrcapi/MallOrder_exportExcelOrderdetails?sessionId=" +
          sessionId +
          "&userId=" +
          userId +
          "&startDate=" +
          startDate +
          "&endDate=" +
          endDate +
          "&shopStoreId=" +
          shopStoreId +
          "&payInterfacePartyType=" +
          payInterfacePartyType +
          "&orderStatus=" +
          orderStatus +
		  "&phoneNum=" +
		  this.phoneNum
      );
    },
    open() {
      this.$confirm("此操作将提交退款 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.request
            .post("qrcapi/MallOrder_refundMallOrder", {
              userId: this.userList.id, //用户Id
              sessionId: this.userList.sessionId,
              mallOrderId: this.id
            })
            .then(res => {
              if (res.code == 1) {
                this.$message({
                  type: "success",
                  message: "提交成功!"
                });
                this.pages = 1; //返回首页
                this.MallOrder_mallOrdersdetails();
              } else if (res.code == 2) {
                this.$message.error(res.msg);
                this.$router.push("/");
              } else {
                this.$message.error(res.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消提交"
          });
        });
    },
    detal(e, id) {
      this.id = id;
      this.pages = e;
      this.MallOrder_toOrderDetail(id);
      this.MallOrder_mallOrderProductPager(id);
      this.MallOrder_refundMallOrderDetail(id);
    },
    orderStatusChange(val) {
      this.value5 = val
    },
    //搜索按钮
    search() {
      // {{this.value5 == 40 ? '完成' : this.value5 == -50 ? '退款' : this.value5 == -51 ? '退货退款' : '全部'}}
      if (this.value5 == -50) {
        // this.refundMoney = true
        this.value6 = "退款"
      } else if (this.value5 == -51) {
        // this.refundGoods = true
        this.value6 = "退货退款"
      } else if (this.value5 == 40) {
        this.value6 = "完成"
      } else {
        this.value6 = "全部"
      }
      this.value4 = this.value2;
      if(!this.value2){
        this.value2 = ''
      }
      this.MallOrder_mallOrdersdetails(
        1,
        this.value,
        this.value2[0],
        this.value2[1],
        this.value3,
        this.value5
      );
    },
    //打印小票
    print() {

      this.buttonDisabled = true;
      setTimeout(() => {
        this.buttonDisabled = false;
      }, 5000);
      printOrder({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        mallOrderId: this.id
      }).then(res => {
        if (res.code == 1) {
         
        var template_html = res.data.htmlContent
          // +
          // '\t\t<div class="section">\n' +
          // '\t\t\t<div class="items" style="margin-bottom:10px;margin-right:-3px"><div class="col-7">物品/规格</div><div class="col-1">数量</div><div class="col-2">小计</div></div>\n' +
          // "\n";
          LODOP.PRINT_INIT("订单小票");
          LODOP.SET_PRINT_STYLE("FontSize", 14);
          LODOP.SET_PRINT_STYLE("Bold", 1); //首先一个初始化语句
          LODOP.ADD_PRINT_HTM(0, 0, "100%", "100%", template_html);
          LODOP.SET_PRINT_PAGESIZE(3, 600, 40, "");
          // LODOP.PREVIEW();//预览
          LODOP.PRINT(); //打印                             //最后一个打印(或预览、维护、设计)语句
          // LODOP.ADD_PRINT_TEXT(0, 0, 100, 20, "文本内容一"); //然后多个ADD语句及SET语句
        } 
        else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });

      // this.request
      //   .post("qrcapi/MallOrder_getPrintContent", {
      //     sessionId: this.userList.sessionId,
      //     userId: this.userList.id,
      //     mallOrderId: this.id
      //   })
      //   .then(res => {
      //     if (res.code == 1) {
      //       this.$message({
      //         message: res.msg,
      //         type: "success"
      //       });
      //     } else if (res.code == 2) {
      //       this.$message.error(res.msg);
      //       this.$router.push("/");
      //     } else {
      //       this.$message.error(res.msg);
      //     }
      //   });
    },
    //重置按钮
    clear() {
      (this.value = ""), (this.value2 = ""), (this.value3 = ""), (this.value5 = ""), (this.phoneNum = "");
    },
    //门店列表
    Shop_shopStores(pageNo) {
      this.request
        .post("qrcapi/Shop_shopStores", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          pageNo: pageNo,
          row: 10
        })
        .then(res => {
          if (res.code == 1) {
            // this.$message({
            //   message: res.msg,
            //   type: "success"
            // });
            // var totalMoney = 0;
            // for (let i in res.data) {
            //   totalMoney += Number(res.data[i].gainMoney);
            // }
            // this.totalMoney = totalMoney;
            for (let i in res.data.list) {
              this.shopList.push(res.data.list[i]);
            }
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    //订单明细
    MallOrder_mallOrdersdetails(
      pageNumber,
      shopStoreId,
      startDate,
      endDate,
      payInterfacePartyType,
      orderStatus
    ) {
      this.request
        .post("qrcapi/MallOrder_mallOrdersdetails", {
          userId: this.userList.id, //用户Id
          sessionId: this.userList.sessionId,
          shopStoreId: shopStoreId, // 门店Id [可选] 若不传 则为所有门店
          startDate: startDate, //筛选开始时间 [可选]
          endDate: endDate, //结束时间 [可选]
          payInterfacePartyType: payInterfacePartyType, //使用哪个支付 [可选]   1.系统  2.支付宝   3.微信
          pageNumber: pageNumber, // 当前页码
          pageSize: 20, // 每页记录数
          orderStatus: this.value5,
		  phoneNum: this.phoneNum,
        })
        .then(res => {
          if (res.code == 1) {
            this.totalCount = res.data.pager.totalCount;
            this.tableData = res.data;
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    //订单商品详情
    MallOrder_mallOrderProductPager(mallOrderId, pageNumber) {
      this.request
        .post("qrcapi/MallOrder_mallOrderProductPager", {
          userId: this.userList.id, //用户Id
          sessionId: this.userList.sessionId,
          mallOrderId: mallOrderId,
          pageNumber: pageNumber, // 当前页码
          pageSize: 7 // 每页记录数
        })
        .then(res => {
          if (res.code == 1) {
            this.orderDetalGoodsList = res.data;
            this.totalCount2 = res.data.pager.totalCount;
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    //订单详情
    MallOrder_toOrderDetail(mallOrderId) {
      this.request
        .post("qrcapi/MallOrder_toManegerOrderDetail", {
          userId: this.userList.id, //用户Id
          sessionId: this.userList.sessionId,
          mallOrderId: mallOrderId
        })
        .then(res => {
       
          if (res.code == 1) {
            this.orderDetalList = res.data;
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    //退款详情
    MallOrder_refundMallOrderDetail(mallOrderId) {
      this.request
        .post("qrcapi/MallOrder_refundMallOrderDetail", {
          userId: this.userList.id, //用户Id
          sessionId: this.userList.sessionId,
          mallOrderId: mallOrderId
        })
        .then(res => {
          if (res.code == 1) {
            this.orderRefundDetalList = res.data;
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            // this.$message.error(res.msg);
          }
        });
    },
    //分页选择每页多少条
    handleSizeChange(val) {},
    //分页当前页
    handleCurrentChange(val) {
      this.value4 = this.value2;

      this.MallOrder_mallOrdersdetails(
        val,
        this.value,
        this.value2[0],
        this.value2[1],
        this.value3
      );
    },
    //分页当前页
    handleCurrentChange2(val) {
      this.MallOrder_mallOrderProductPager(this.id, val);
    },
    handleCurrentChange3(val) {
      this.MallOrder_mallOrderProductPager(this.id, val);
    }
  }
};
</script>

<style scoped>
.billHead {
  box-sizing: border-box;
  width: 100%;
  padding: 30px 0px 20px 30px;
  background: #f8f8f8;
  padding-top: 80px;
}
.billHead2 {
  box-sizing: border-box;
  width: 100%;
  background: #f8f8f8;
  padding: 13px 0 0 25px;
  position: fixed;
  top: 49px;
  z-index: 100;
}
.input1 {
  width: 200px;
}
.margin20 {
  margin-left: 20px;
}
.button1 {
  height: 30px;
  padding: 0 10px;
}
.content {
  padding: 20px 30px;
}
.button5 {
  width: 45px;
  height: 30px;
  padding: 0;
  color: #409eff;
  border: 1px solid #409eff;
}
.button2 {
  width: 70px;
  height: 30px;
  padding: 0;
  position: absolute;
  right: 100px;
  bottom: 20px;
}
.button6 {
  width: 70px;
  height: 30px;
  padding: 0;
  color: #409eff;
  border: 1px solid #409eff;
  position: absolute;
  right: 20px;
  bottom: 20px;
}
.content img {
  height: 30px;
  width: 30px;
}
.content .time {
  font-size: 12px;
  margin-bottom: 20px;
}
.content .red {
  color: red;
}
#page2 .content {
  box-sizing: border-box;
  padding: 30px;
  padding-top: 120px;
}
#page2 .state,
#page3 .state {
  box-sizing: border-box;
  background: #f8f8f8;
  height: 185px;
  width: 275px;
  padding: 10px;
}
#page2 .state img,
#page3 .state img {
  height: 47px;
  width: 47px;
  margin-top: 10px;
}
#page2 .title,
#page3 .title {
  width: 100%;
  font-size: 12px;
  font-weight: 600;
}
#page2 .text1,
#page3 .text1 {
  color: #ff6e6e;
  font-size: 17px;
  font-weight: 500;
  margin-top: 10px;
}
#page2 .text2,
#page3 .text2 {
  margin-top: 10px;
  font-size: 12px;
}
.primary {
  position: relative;
  width: calc(100% - 295px);
  box-sizing: border-box;
  background: #f8f8f8;
  margin-left: 20px;
  height: 185px;
  padding: 10px 25px;
}
.primaryContent {
  margin-top: 30px;
  font-size: 12px;
  color: #767676;
}
.primaryContent .block1 div:not(:first-child) {
  margin-top: 10px;
}
.primaryContent .block2 div:not(:first-child) {
  margin-top: 10px;
}
.primaryContent .block2 {
  margin-left: 85px;
}
#page3 .content {
  padding: 30px;
  padding-top: 120px;
}
#page3 .top {
  box-sizing: border-box;
  width: 100%;
  height: 125px;
  padding: 12px 25px;
  background: #f8f8f8;
}
.blue {
  color: #2f9ceb;
  cursor:pointer
}
</style>


// WEBPACK FOOTER //
// src/components/page/bill.vue